import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchWinRatio } from './userActions';
import { WinRatioResponse, WinRatioState } from './types';

const initialState: WinRatioState = {
  winRatio: null,
  loading: false,
  error: null
};

const winRatioSlice = createSlice({
  name: 'winRatio',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWinRatio.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWinRatio.fulfilled, (state, action: PayloadAction<WinRatioResponse>) => {
        state.loading = false;
        state.winRatio = action.payload.data;
        state.error = null;
      })
      .addCase(fetchWinRatio.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default winRatioSlice.reducer;